import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-notification-snackbar",
	templateUrl: "./notification-snackbar.component.html",
	styleUrls: ["./notification-snackbar.component.css"],
	standalone: false,
})
export class NotificationSnackbarComponent implements OnInit {
	@Input() text: string = "Successfully updated";
	@Input() icon: string = "done";
	@Input() color: string = "#ff9545";

	ngOnInit(): void {}
}
